<!--
    描述：签署流程信息
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          签署流程ID：{{formObj.bizNumber}}
        </el-col>
        <el-col :span="12">
          流程状态：
          <span v-if="formObj.flowState == 2">成功</span>
          <span v-if="formObj.flowState == 3">失败</span>
          <span v-if="formObj.flowState == 4">拒签</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          流程创建人：{{formObj.createUserName}}
        </el-col>
        <el-col :span="12">
          流程创建时间：{{formObj.createDate}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          流程结束回调地址：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          流程关联的签署信息：
        </el-col>
      </el-row>

      <div class="table-content">
        <el-table ref="xTable"
                  :data="tableObj.data"
                  highlight-current-row
                  :height="tableObj.height"
                  size="mini"
                  border>
          <el-table-column type="index"
                           label="序号"
                           align="center"
                           width="65">
          </el-table-column>
          <el-table-column prop=""
                           label="业务流水号"
                           align="center"
                           width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="flowId"
                           label="签署流程ID"
                           align="center"
                           width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="accountId"
                           label="发起人会员ID"
                           align="center"
                           width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="createUserName"
                           label="发起人名称"
                           width="110"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="ralName"
                           label="主体类型"
                           width="150"
                           align="center"
                           show-overflow-tooltip>

          </el-table-column>
          <el-table-column prop="companyName"
                           label="待签署文件ID"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop=""
                           label="文件名称"
                           width="200"
                           align="center"
                           show-overflow-tooltip>

          </el-table-column>
          <el-table-column prop="companyName"
                           label="业务来源"
                           width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="createDate"
                           label="流程发起时间"
                           width="165"
                           header-align="center"
                           sortable
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName"
                           label="状态"
                           width="100"
                           header-align="center"
                           sortable
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.flowState ==2">成功</span>
              <span v-if="scope.row.flowState ==3">失败</span>
              <span v-if="scope.row.flowState ==4">拒签</span>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           width="100">
            <template slot="header">操作</template>
            <template slot-scope="scope">
              <el-button type="primary"
                         size="small"
                         round
                         plain
                         class="table-btn"
                         v-if="roleBtns.includes('contractDetail')"
                         @click="showDetail(scope.row)">
                <svg-icon icon-class="form-details"></svg-icon>
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from 'api/modules/es/es_order.js'
import * as APIHistory from 'api/modules/es/es_order_history.js'
import {mapState} from "vuex";
export default {
  name : 'detail_tab_sfi',
  components: {

  },
  data() {
    return {
      formObj : {

      },
      tableObj : {
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
        data : [],
        height : '440px'
      },
    }
  },
  mounted() {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  computed: {
    ...mapState('app', { isBack: (state) => state.isBack }),
    ...mapState('menu', {
      roleBtns: (state) => state.roleBtns,
    }),
    orderId() {
      return this.$route.query.id
    },
  },
  created() {
    this.getObjectById()
    this.getOrderHistoryTableList()
  },
  methods: {
    getObjectById(){
      API.getObjectById({id: this.orderId}).then(res=>{
        if(res.operationCode == 1) {
          this.formObj = res.data
        }
      })
    },
    getOrderHistoryTableList(){
      let param = {
        orderId : this.orderId
      }
      APIHistory.getTableList(param).then(res=>{
        if(res.operationCode == 1) {
          this.tableObj.data = res.data
        }
      })
    },

    showDetail(row){

    },
  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }

    .table-content {

    }
  }
}
</style>